import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/inputTextLimit';

const validate = values => {
    const errors = {};

    if (values.homeSectionTitle1) {
        let errorHomeSectionTitle = [];
        if (values?.homeSectionTitle1?.map((item, index) => {
            const homeSectionError = {}
            if (!item?.value || item?.value.toString().trim() === '') {
                homeSectionError.value = messages.required;
                errorHomeSectionTitle[index] = homeSectionError;
            } else if (item?.value?.length > inputTextLimit) {
                homeSectionError.value = messages.inputTextLimitError;
                errorHomeSectionTitle[index] = homeSectionError;
            }

            if (!item?.language || item?.language.toString().trim() === '') {
                homeSectionError.language = messages.required;
                errorHomeSectionTitle[index] = homeSectionError;
            }
        }));
        if (errorHomeSectionTitle?.length > 0) errors.homeSectionTitle1 = errorHomeSectionTitle;
    }


    return errors;
};

export default validate;